import script from "./MsBaseComponent.vue?vue&type=script&lang=js"
export * from "./MsBaseComponent.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__